import React from 'react';
import styles from './styles.module.scss';

import LinkWrap from '../../Wraps/LinkWrap';

import Config, { spanish } from '../../../config/config';

const BottomBanner = ({ data }) => {
  const banner = data?.find((item) => item?.Position === 'Bottom');
  let linkTo = banner?.LinkTo;
  let linkState = {};
  if (banner?.product !== null) {
    linkTo = `/product/${banner?.product?.SLUG}`;
    linkState = { sku: banner?.product?.SKU };
  } else if (banner?.category !== null) {
    linkTo = `/category/${banner?.category?.SLUG}`;
    linkState = {
      categoryId: banner?.category?.categoryID,
      categoryName: spanish
        ? banner?.category?.NameSpanish
        : banner?.category?.NameEnglish,
    };
  }
  return (
    <div className={styles.container}>
      <LinkWrap
        to={linkTo}
        className={styles.item}
        state={linkState}
        isExternal={banner?.isExternal}
      >
        <picture>
          <source
            srcSet={`${Config.cdn.cdn_path}${
              spanish
                ? banner?.imageDesktop?.url
                : banner?.imageDesktopEnglish?.url
            }`}
            media="(min-width: 760px)"
          />
          <img
            src={`${Config.cdn.cdn_path}${
              spanish
                ? banner?.imageMobile?.url
                : banner?.imageMobileEnglish?.url
            }`}
            alt={banner?.SEO}
          />
        </picture>
      </LinkWrap>
    </div>
  );
};

export default BottomBanner;
